import { render, staticRenderFns } from "./CroutonPlaceholder.vue?vue&type=template&id=846df04e&functional=true&"
import script from "./CroutonPlaceholder.vue?vue&type=script&lang=js&"
export * from "./CroutonPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports